import { useMemo } from 'react';
import { DropdownPeriodType } from './FiscalYearsTableGridToolbar';

export interface PeriodsError {
  isEmpty: string[];
  isZero: string[];
  isOne: string[];
}

const defaultPeriods: PeriodsError = {
  isEmpty: [],
  isZero: [],
  isOne: [],
};

const useCreateNewYearErrors = (
  noOfPeriod: number,
  periodLength: number,
  periodType: DropdownPeriodType
) => {
  const noOfPeriods = useMemo(() => {
    let error: PeriodsError = { ...defaultPeriods };
    if ((noOfPeriod as unknown as string) === '' || noOfPeriod === undefined) {
      error.isEmpty = ['Number of Periods must be entered'];
    } else if (Number(noOfPeriod) === 0) {
      error.isZero = ['Number of Periods cannot be zero'];
    }
    return error;
  }, [noOfPeriod]);

  const periodsLength = useMemo(() => {
    let error: PeriodsError = { ...defaultPeriods };
    if ((periodLength as unknown as string) === '' || periodLength === undefined) {
      error.isEmpty = ['Period length must be entered'];
    } else if (Number(periodLength) === 0 || (periodLength === 1 && periodType?.id === 0)) {
      error.isZero = ['Period length should be greater than one'];
    }
    return error;
  }, [periodLength, periodType?.id]);

  const noOfPeriodsErrorList: string[] = [
    ...Object?.values(noOfPeriods)
      ?.map((i) => Object?.values(i)?.flat())
      ?.flat(),
  ] as string[];
  const PeriodsLengthErrorList: string[] = [
    ...Object?.values(periodsLength)
      ?.map((i) => Object?.values(i)?.flat())
      ?.flat(),
  ] as string[];

  const hasNoOfPeriodsErrors = useMemo(
    () => !!noOfPeriodsErrorList.length,
    [noOfPeriodsErrorList.length]
  );
  const hasPeriodsLengthErrors = useMemo(
    () => !!PeriodsLengthErrorList.length,
    [PeriodsLengthErrorList.length]
  );

  return {
    noOfPeriods,
    periodsLength,
    noOfPeriodsErrorList,
    PeriodsLengthErrorList,
    hasNoOfPeriodsErrors,
    hasPeriodsLengthErrors,
  };
};

export default useCreateNewYearErrors;
